import ServerApi from './$server.api'

export default {
    getTrackingsShipment,
    findTrackingShipment,
}

async function getTrackingsShipment(shipmentId, query = {}) {
    return await ServerApi.request('get', `/trackings/shipment/${ shipmentId }`, {query})
}

async function findTrackingShipment(data) {
    return await ServerApi.request('post', '/trackings/shipment/', {data})
}